(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mjs-support-footer"]) return;
  try {
    
  (() => {
    const schedule = {
      0: { label: 'SUNDAY', open: 720, close: 1020, openText: '12:00 PM', closeText: '5:00 PM' },
      1: { label: 'MONDAY', open: 600, close: 1140, openText: '10:00 AM', closeText: '7:00 PM' },
      2: { label: 'TUESDAY', open: 600, close: 1140, openText: '10:00 AM', closeText: '7:00 PM' },
      3: { label: 'WEDNESDAY', open: 600, close: 1140, openText: '10:00 AM', closeText: '7:00 PM' },
      4: { label: 'THURSDAY', open: 600, close: 1140, openText: '10:00 AM', closeText: '7:00 PM' },
      5: { label: 'FRIDAY', open: 600, close: 1140, openText: '10:00 AM', closeText: '7:00 PM' },
      6: { label: 'SATURDAY', open: 600, close: 1020, openText: '10:00 AM', closeText: '5:00 PM' }
    };

    const getEasternNow = () => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());

      const weekday = parts.find((part) => part.type === 'weekday')?.value || 'Sun';
      const weekdayIndex = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(weekday);
      const hour = Number(parts.find((part) => part.type === 'hour')?.value || 0);
      const minute = Number(parts.find((part) => part.type === 'minute')?.value || 0);

      return {
        day: weekdayIndex < 0 ? 0 : weekdayIndex,
        minutes: (hour * 60) + minute
      };
    };

    const updateStatus = () => {
      const now = getEasternNow();
      const today = schedule[now.day];
      const isOpen = now.minutes >= today.open && now.minutes < today.close;

      let detail;
      if (isOpen) {
        detail = `UNTIL ${today.closeText} ET`;
      } else if (now.minutes < today.open) {
        detail = `OPENS TODAY ${today.openText} ET`;
      } else {
        const nextDay = schedule[(now.day + 1) % 7];
        detail = `OPENS ${nextDay.label} ${nextDay.openText} ET`;
      }

      document.querySelectorAll('[data-mjs-live-status]').forEach((status) => {
        status.dataset.state = isOpen ? 'open' : 'closed';

        const copy = status.querySelector('[data-mjs-status-copy]');
        const detailNode = status.querySelector('[data-mjs-status-detail]');

        if (copy) copy.textContent = isOpen ? 'OPEN NOW' : 'CLOSED NOW';
        if (detailNode) detailNode.textContent = detail;

        status.setAttribute(
          'aria-label',
          isOpen
            ? `Project MJS is open now until ${today.closeText} Eastern Time`
            : `Project MJS is closed now. ${detail.toLowerCase()}`
        );
      });
    };

    updateStatus();

    if (window.__mjsFooterStatusInterval) {
      window.clearInterval(window.__mjsFooterStatusInterval);
    }
    window.__mjsFooterStatusInterval = window.setInterval(updateStatus, 60000);
    document.addEventListener('shopify:section:load', updateStatus);
  })();

  } catch(e) { console.error(e); }
})();
})();
